import { useEffect, useState } from 'react';
import { api, type AdminMe } from '../../lib/api.js';

export function AdminAccount() {
  const [me, setMe] = useState<AdminMe | null>(null);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get<AdminMe>('/api/admin/me')
      .then(setMe)
      .catch((err) => setError((err as Error).message));
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    if (next !== confirmPw) {
      setError('새 비밀번호가 일치하지 않습니다.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/admin/account/change-password', {
        currentPassword: current,
        newPassword: next,
      });
      setSuccess(true);
      setCurrent('');
      setNext('');
      setConfirmPw('');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">내 정보</h1>
      </header>

      {me && (
        <div className="mb-8 bg-surface border border-neutral-200 rounded-lg p-6">
          <dl className="grid grid-cols-[120px_1fr] gap-y-3 text-sm">
            <dt className="text-neutral-500">이메일</dt>
            <dd className="font-medium">{me.email}</dd>
            <dt className="text-neutral-500">이름</dt>
            <dd className="font-medium">{me.displayName}</dd>
            <dt className="text-neutral-500">역할</dt>
            <dd className="font-medium">{me.role}</dd>
          </dl>
        </div>
      )}

      <h2 className="text-lg font-medium mb-2">비밀번호 변경</h2>
      <form
        onSubmit={submit}
        className="max-w-md bg-surface border border-neutral-200 rounded-lg p-6 space-y-4"
      >
        <label className="block">
          <span className="block text-sm font-medium text-neutral-800 mb-1">현재 비밀번호</span>
          <input
            type="password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
            autoComplete="current-password"
            className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-neutral-800 mb-1">
            새 비밀번호 (12자 이상)
          </span>
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
            minLength={12}
            autoComplete="new-password"
            className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-neutral-800 mb-1">새 비밀번호 확인</span>
          <input
            type="password"
            value={confirmPw}
            onChange={(e) => setConfirmPw(e.target.value)}
            required
            autoComplete="new-password"
            className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </label>
        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
            {error}
          </div>
        )}
        {success && (
          <div className="p-3 bg-green-50 border border-green-200 rounded-md text-sm text-green-700">
            변경되었습니다.
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 bg-brand-400 hover:bg-brand-600 disabled:bg-neutral-300 text-white text-sm font-medium rounded-md"
        >
          {loading ? '변경 중…' : '비밀번호 변경'}
        </button>
      </form>
    </div>
  );
}
